// extracted by mini-css-extract-plugin
export var formContainer = "_iw-0";
export var message = "_iw-1";